import Big from 'big.js';

import { ensureBig } from './big-conversion';

/**
 * Formats a number with comma separators using Japanese locale / 日本のロケールを使用して数値をカンマ区切りでフォーマットします
 *
 * This function converts a number into a string with comma separators for thousands, millions, etc.,
 * using the Japanese locale formatting rules.
 * 数値を千、百万などでカンマ区切りした文字列に変換します。日本のロケールフォーマットルールを使用します。
 *
 * @param {number} num - The number to format / フォーマットする数値
 * @returns {string} The formatted number string with comma separators / カンマ区切りでフォーマットされた数値文字列
 *
 * @example
 * // Returns "1,234" / "1,234"を返します
 * addComma(1234);
 *
 * @example
 * // Returns "1,234,567" / "1,234,567"を返します
 * addComma(1234567);
 *
 * @example
 * // Returns "0" / "0"を返します
 * addComma(0);
 */
export function addComma(value: Big | number): string {
  const big = ensureBig(value);

  // BigJSから文字列表現を取得（科学的記法を避けるためtoFixed使用）
  // 十分な精度でtoFixedを使用して科学的記法を回避
  let valueStr = big.toFixed();

  // 不要な末尾の0を削除
  if (valueStr.includes('.')) {
    valueStr = valueStr.replace(/\.?0+$/, '');
  }

  const isNegative = valueStr.startsWith('-');
  const absValueStr = isNegative ? valueStr.slice(1) : valueStr;

  // 整数部分と小数部分を分離
  const [integerPart, decimalPart] = absValueStr.split('.');

  // 整数部分に3桁ごとにカンマを挿入
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  // 結果を組み立て
  let result = formattedInteger;
  if (decimalPart !== undefined) {
    result += '.' + decimalPart;
  }

  return isNegative ? '-' + result : result;
}
